import React from "react";
import "./TpPopUpCss.css";

const PopUpContent = ({ content, error, ...rest }) => {
  return <div className="popup-content">{content}</div>;
};

export default PopUpContent;
